'use memo'
import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import TaskDueDateBadge from 'components/tasks/TaskDueDateBadge'
import { getStepsCompletionInfo } from 'utils/tasks'

interface TaskDueCellProps {
  task: AutopilotTaskDto
}

const TaskDueCell = ({ task }: TaskDueCellProps) => {
  const { dueDate } = task

  const dueDateStr = dueDate as unknown as string

  if (!dueDateStr) return null
  const { latestCompletedDate } = getStepsCompletionInfo([task])

  return (
    <TaskDueDateBadge
      dueDate={dueDateStr}
      isCompleted={task.isCompleted ?? false}
      completedDate={latestCompletedDate}
    />
  )
}

export default TaskDueCell
